/* global window */
import { HEADER_OFFSET } from 'Constants/items';

/**
 * Smooth Scroll to the ref provided
 * @param {*} ref - React ref
 * @returns undefined
 */
export const handleScrollToTargetAdjusted = (ref, additionalOffset = 0) => {
    const element = ref.current;

    if (!element) {
        return;
    }

    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - additionalOffset - HEADER_OFFSET;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
};
